(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-image-counter"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wrap = document.querySelector('#shopify-section-header .header__wrapper');
  var header = document.querySelector('#shopify-section-header .theme__header');

  function setBackfill(){
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--menu-backfill-height', h+'px');
  }
  function forceTransparent(){
    if (wrap && wrap.getAttribute('data-header-transparent') !== 'true'){
      wrap.setAttribute('data-header-transparent','true');
    }
  }

  setBackfill();
  forceTransparent();
  window.addEventListener('resize', setBackfill);

  if (wrap){
    new MutationObserver(forceTransparent).observe(wrap, {attributes:true, attributeFilter:['data-header-transparent']});
  }
})();

(function() {
  /* ----------------- COUNTDOWN ----------------- */
  function initCountdown(root) {
    if (!root || root.dataset.dicInit === '1') return;
    root.dataset.dicInit = '1';

    var mode = root.getAttribute('data-mode') || 'fixed';
    var isoFixed = (root.getAttribute('data-target') || '').trim();
    var localStr = (root.getAttribute('data-target-local') || '').trim();
    var timer = root.querySelector('.dic__timer');
    var hintEl = root.querySelector('.dic__datetime-hint');
    var notifyCta = root.querySelector('.dic__cta');
    var endedCta  = root.querySelector('.dic__ended-cta');

    var nums = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    function pad2(n) { n = Math.floor(Math.abs(n)); return n < 10 ? '0' + n : String(n); }

    function parseFixedManual(s) {
      if (!s) return null;
      s = s.replace(' ', 'T');
      var m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d+))?(Z|[+-]\d{2}:?\d{2})$/);
      if (!m) return null;
      var Y = +m[1], Mo = +m[2]-1, D = +m[3], H = +m[4], Mi = +m[5], S = +(m[6]||0);
      var tz = m[8];
      var offMin = 0;
      if (tz !== 'Z') {
        var sign = tz[0] === '-' ? -1 : 1;
        var hh = +tz.slice(1,3);
        var mm = +tz.slice(-2);
        offMin = sign * (hh*60 + mm);
      }
      var utc = Date.UTC(Y, Mo, D, H - Math.trunc(offMin/60), Mi - (offMin % 60), S);
      return new Date(utc);
    }

    function parseLocalManual(s) {
      if (!s) return null;
      s = s.replace(' ', 'T');
      var m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!m) return null;
      var Y = +m[1], Mo = +m[2]-1, D = +m[3], H = +m[4], Mi = +m[5], S = +(m[6]||0);
      return new Date(Y, Mo, D, H, Mi, S);
    }

    var targetDate = (mode === 'local') ? parseLocalManual(localStr) : parseFixedManual(isoFixed);

    function renderHint() {
      if (!hintEl || !targetDate) return;
      var prefix = hintEl.getAttribute('data-hint-prefix') || '';
      try {
        var df = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short', timeZoneName: 'short' });
        hintEl.textContent = prefix + ' ' + df.format(targetDate) + (mode === 'local' ? ' (heure locale)' : '');
      } catch (e) {
        hintEl.textContent = prefix + ' ' + targetDate.toLocaleString();
      }
    }

    function update() {
      if (!targetDate || !timer) return;
      var now = new Date();
      var diff = targetDate - now;

      if (diff <= 0) {
        nums.days.textContent = '00';
        nums.hours.textContent = '00';
        nums.minutes.textContent = '00';
        nums.seconds.textContent = '00';

        if (timer) timer.setAttribute('hidden', '');
        if (notifyCta) notifyCta.setAttribute('hidden', '');
        if (endedCta) endedCta.removeAttribute('hidden');
        return;
      }

      var totalSecs = Math.floor(diff / 1000);
      var days = Math.floor(totalSecs / 86400);
      var hours = Math.floor((totalSecs % 86400) / 3600);
      var mins = Math.floor((totalSecs % 3600) / 60);
      var secs = totalSecs % 60;

      nums.days.textContent = String(days).padStart(2, '0');
      nums.hours.textContent = pad2(hours);
      nums.minutes.textContent = pad2(mins);
      nums.seconds.textContent = pad2(secs);
    }

    if (!targetDate || isNaN(targetDate.getTime())) {
      if (hintEl) hintEl.textContent = 'Date invalide. Exemple: 2025-11-18T18:00:00+01:00';
      return;
    }

    renderHint();
    update();

    var intId = setInterval(function() {
      update();
      if (timer && timer.hasAttribute('hidden')) clearInterval(intId);
    }, 1000);

    document.addEventListener('shopify:section:unload', function(e){
      if (e.target && e.target.contains(root)) {
        clearInterval(intId);
        root.dataset.dicInit = '';
      }
    });
  }

  function bootAll() {
    document.querySelectorAll('.drop-image-counter').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('.drop-image-counter');
    if (el) initCountdown(el);
  });
  document.addEventListener('shopify:section:select', function(e){
    var el = e.target.querySelector('.drop-image-counter');
    if (el) initCountdown(el);
  });

  /* --------------- FORM DIRECT (Brevo) --------------- */
  function initBrevoForms(scope){
    (scope || document).querySelectorAll('.drop-image-counter .dic__cta form.dic__form').forEach(function(form){
      if (form.dataset.dicBrevoInit === '1') return;
      form.dataset.dicBrevoInit = '1';

      var input = form.querySelector('.dic__input');
      var msg   = form.querySelector('.dic__msg');
      var frameName = form.getAttribute('target');
      var frame = frameName ? (form.parentElement.querySelector('iframe[name="'+frameName+'"]')) : null;

      var successText = (form.getAttribute('data-success-text') || "Thanks, you’re on the list.").trim();
      var errorText   = (form.getAttribute('data-error-text') || 'Adresse e-mail invalide.').trim();

      function isValidEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v||'').trim()); }

      form.addEventListener('submit', function(ev){
        if (!input || !msg) return;

        input.classList.remove('is-error');
        msg.textContent = '';
        msg.className = 'dic__msg';

        if (!isValidEmail(input.value)){
          ev.preventDefault();
          input.classList.add('is-error');
          msg.textContent = errorText;
          msg.className = 'dic__msg dic__msg--err';
          input.focus();
          return;
        }

        var submitBtn = form.querySelector('.dic__submit');
        if (submitBtn) submitBtn.setAttribute('disabled','disabled');
      });

      if (frame){
        frame.addEventListener('load', function(){
          var ok = document.createElement('span');
          ok.className = 'dic__msg dic__msg--ok';
          ok.textContent = successText;
          form.innerHTML = '';
          form.appendChild(ok);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initBrevoForms(document); });
  } else {
    initBrevoForms(document);
  }

  document.addEventListener('shopify:section:load', function(e){
    initBrevoForms(e.target);
  });
  document.addEventListener('shopify:section:select', function(e){
    initBrevoForms(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
